// extracted by mini-css-extract-plugin
export default {"toggle":"styles_toggle__9jX7z","boxpadding":"styles_boxpadding__QaHa3","row":"styles_row__Jycel","heading":"styles_heading__X+B6u","date":"styles_date__os5-k"};